import QuestionTypes from 'bundles/author-questions/constants/QuestionTypes';
import type { QuizQuestionPrompt } from 'bundles/compound-assessments/types/FormParts';
import type { InVideoQuestion } from 'bundles/video-quiz/types';

export const isPollQuestion = <T extends QuizQuestionPrompt>(question: InVideoQuestion<T>) => {
  return [QuestionTypes.Poll, QuestionTypes.CheckboxPoll].includes(question.question.type);
};

export const isPauseAndReflectQuestion = <T extends QuizQuestionPrompt>(question: InVideoQuestion<T>) => {
  return [QuestionTypes.ReflectText, QuestionTypes.Continue].includes(question.question.type);
};
